export default __webpack_public_path__ + "static/media/exclamation-white-small.df7857a3.svg";